

angular.module('trainerWebApp.services').factory('accountCustomFields', [function() {
  var _customFields = [];

  function setCustomFields(customFields) {
    _customFields = customFields;
  }

  return {
    setCustomFields: setCustomFields,
    getCustomFields: function () {
      return _customFields.concat();
    }
  };
}]);
